import { CurrentPriceMessageElement } from "Components/CurrentPriceMessage/CurrentPriceMessageElement";
import { CurrentPriceMessageWithUnselectedCoverageElement } from "Components/CurrentPriceMessage/CurrentPriceMessageWithUnselectedCoverageElement";
import { getPrice } from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/vehicleUtils";
import { ProductBackendName } from "Components/Features/CheckPrice/Products/productTypes";
import { CoveragePriceCalculation } from "Components/Features/CheckPrice/Tiles/ProductPriceTile/Coverages/coverages.types";
import { InsuranceCoverage } from "Store/interfaces/products/coverage";
import { usePriceCalculationSelector } from "Store/priceCalculation/priceCalculationSelectors";
import { isDefined } from "Utils/functions";
import React, { ReactElement } from "react";

export interface SelectedPrice {
  readonly selectedCoverage: InsuranceCoverage | undefined;
  readonly selectedDeductible: string | undefined;
  readonly defaultDeductible: string | undefined;
}

interface CurrentPriceMessageProps {
  readonly productBackendName: ProductBackendName;
  readonly coverages: CoveragePriceCalculation[];
  readonly selectedPrices: SelectedPrice[];
  readonly sticky?: boolean;
}

export const CurrentPriceMessage = ({
  coverages,
  selectedPrices,
  sticky = true,
  productBackendName,
}: CurrentPriceMessageProps): ReactElement | null => {
  const {
    priceCalculationResult: { current: priceResult },
  } = usePriceCalculationSelector();
  const currentSelectedPrices = selectedPrices
    .map(({ selectedCoverage, selectedDeductible, defaultDeductible }) => {
      if (selectedDeductible && defaultDeductible && selectedCoverage) {
        return getPrice(
          coverages,
          selectedCoverage,
          selectedDeductible,
          defaultDeductible,
        );
      }
    })
    .filter(isDefined);

  if (!isDefined(currentSelectedPrices) || currentSelectedPrices.length === 0) {
    if (isDefined(priceResult)) {
      return (
        <CurrentPriceMessageWithUnselectedCoverageElement
          sticky={sticky}
          productBackendName={productBackendName}
        />
      );
    }
    return null;
  }
  if (isDefined(currentSelectedPrices)) {
    return (
      <CurrentPriceMessageElement
        selectedPrices={currentSelectedPrices}
        sticky={sticky}
        productBackendName={productBackendName}
      />
    );
  }
  return null;
};
